import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';
import umbrellaChair from 'assets/illustrations/umbrella-chair.webp';
import { gradients } from 'theme/mixins';

function Illustration() {
    return (
        <Box
            sx={{
                width: 108,
                height: 92,
                bgcolor: 'common.white',
                borderRadius: 6,
                boxShadow: '-6px 6px 0 0 #000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Box
                component="img"
                src={umbrellaChair}
                alt="Beach chair and umbrella"
                sx={{ width: '80%', height: '80%', objectFit: 'contain' }}
            />
        </Box>
    );
}

export default function TaskCarouselCelebration({ onClose }: Readonly<{ onClose: () => void }>) {
    return (
        <Paper
            elevation={0}
            data-mobile-flat
            sx={{
                position: 'relative',
                background: gradients.primaryPurple,
                color: 'common.white',
                p: 3,
                minHeight: 224,
                borderRadius: { xs: 0, sm: 4 },
            }}>
            <IconButton
                onClick={onClose}
                size="small"
                aria-label="Dismiss banner"
                sx={{ position: 'absolute', top: 16, right: 16, color: 'common.white' }}>
                <CloseXIcon sx={{ fontSize: 24 }} />
            </IconButton>
            <Stack spacing={3} alignItems="center">
                <Illustration />
                <Stack spacing={0.5} alignItems="center">
                    <Typography variant="h2" sx={{ textAlign: 'center' }}>
                        Done.
                    </Typography>
                    <Typography variant="h2" sx={{ textAlign: 'center' }}>
                        Now, go be unproductive for a while.
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    );
}
